import { useEffect, useState } from "react";

/**
 * Renders children only after the first client-side effect.
 *
 * Used to gate non-essential floating widgets (chat, toaster, live activity)
 * so they don't end up in the static prerendered HTML and cause hydration
 * mismatches when their first-render output is non-deterministic (sonner CSS
 * injection, time-based content, etc.).
 *
 * SEO-critical content must NEVER live inside ClientOnly.
 */
export default function ClientOnly({ children }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return children;
}
